import React from 'react';
import { Container, Row, Col, BodyText, Loader } from 'shared-portal-component';

import type { PasswordUpdateStage } from '@/types/passwordUpdate/PasswordUpdate';

interface UpdatePasswordProgressProps {
  stage: PasswordUpdateStage;
  message: string;
  processed: number;
  total: number;
}

const stageLabels: Record<PasswordUpdateStage, string> = {
  idle: '',
  validatingOldPassword: 'Validating password',
  updatingCredentials: 'Updating credentials',
  reEncryptingFileKeys: 'Re-encrypting file keys',
  complete: 'Complete',
  error: 'Error',
};

export default function UpdatePasswordProgress({
  stage,
  message,
  processed,
  total,
}: UpdatePasswordProgressProps) {
  const isActive = stage !== 'idle' && stage !== 'complete' && stage !== 'error';

  return (
    <Container fluid className="py-8">
      <Row spacing="md" justify="center">
        <Col size={12} className="flex flex-col items-center gap-6">
          {isActive && <Loader />}

          <BodyText as="p" className="text-center text-lg font-medium">
            {stageLabels[stage]}
          </BodyText>

          <BodyText as="p" className="text-center">
            {message}
          </BodyText>

          {stage === 'reEncryptingFileKeys' && total > 0 && (
            <BodyText as="p" className="text-center text-sm text-muted-foreground">
              {processed} / {total} file keys processed
            </BodyText>
          )}

          {isActive && (
            <BodyText as="p" className="text-center text-sm text-muted-foreground">
              Please be patient. Do not close this window.
            </BodyText>
          )}
        </Col>
      </Row>
    </Container>
  );
}
